import React from 'react';

export class SearchForm extends React.Component {
	constructor(props) {
		super(props);
		this.searchList = this.searchList.bind(this);
	}

	searchList(page) {
		// Declare variables
		var input, filter, li, button, errorMessage, i, allTabs, tab1, display;
		input = document.querySelectorAll('#'+page+' input#search-'+page)[0];
		filter = input.value.toUpperCase();
		li = document.querySelectorAll("#"+page+" .result-list li");
		errorMessage = document.querySelectorAll("#"+page+" #search-error")[0];
		allTabs = document.querySelectorAll("#"+page+" .list-tabs .tab");
		tab1 = document.querySelectorAll("#"+page+" #tab-1")[0];

		if (filter) {
			if (errorMessage) {
				errorMessage.remove();
				input.classList.remove("error");
			}
			var count = li.length;
			for (i = 0; i < li.length; i++) {
				if (page === "endpoints") {
					button = li[i].getElementsByTagName("a")[0];
					display = "block";
				} else if (page === "uptime") {
					button = li[i].getElementsByTagName("h3")[0];
					display = "inline-block";
				} else {
					button = li[i].getElementsByTagName("button")[0];
					display = "block";
				}


				if (button.innerHTML.toUpperCase().indexOf(filter) > -1) {
					li[i].style.display = display;
					count++;
				} else {
					li[i].style.display = "none";
					count--;
				}
				
			}

			if (allTabs && tab1) {
				for (i = 0; i < allTabs.length; i++) {
					allTabs[i].classList.remove("active");
				}
				tab1.classList.add("active");
			}

			if (count === 0) {
				document.querySelectorAll("#"+page+" #search"+page)[0].insertAdjacentHTML(
					'beforeend',
					'<em id="search-error">Your search returned no results...</em>'
					);
				input.classList.add("error");
			}
		} else {
			if (filter) {
				if (!errorMessage) {
					document.querySelectorAll("#"+page+" .search"+page)[0].insertAdjacentHTML(
						'beforeend',
						'<em id="search-error">Something went wrong with your search</em>'
						);
				}
			} else {
				for (var b=0;b<li.length;b+=1){
					li[b].style.display = '';
				}
			}
		}
	}

	render() {
		let page = this.props.page;
		
		return (
			<form className="form search-form" id={"search"+page}>
				<input
				type="text"
				className="input"
				id={"search-"+page}
				placeholder={"Search results..."}
				onKeyUp={() => this.searchList(page)}
				/>
			</form>
		)
	}
}


// WEBPACK FOOTER //
// ./src/helpers/uiComponents/Search.js